import type { ComponentType, SVGProps } from 'react';
import SolarAddCircleBold from './SolarAddCircleBold';
import SolarAddCircleLinear from './SolarAddCircleLinear';
import SolarAlignVerticalSpacingLinear from './SolarAlignVerticalSpacingLinear';
import SolarAltArrowDownLinear from './SolarAltArrowDownLinear';
import SolarAltArrowLeftLinear from './SolarAltArrowLeftLinear';
import SolarAltArrowRightLinear from './SolarAltArrowRightLinear';
import SolarAltArrowUpLinear from './SolarAltArrowUpLinear';
import SolarArchiveDownLinear from './SolarArchiveDownLinear';
import SolarArchiveLinear from './SolarArchiveLinear';
import SolarArrowRightLinear from './SolarArrowRightLinear';
import SolarArrowUpLinear from './SolarArrowUpLinear';
import SolarBellLinear from './SolarBellLinear';
import SolarBookmarkBold from './SolarBookmarkBold';
import SolarBookmarkSquareLinear from './SolarBookmarkSquareLinear';
import SolarBoxMinimalisticLinear from './SolarBoxMinimalisticLinear';
import SolarBuildingsLinear from './SolarBuildingsLinear';
import SolarCalendarDateLinear from './SolarCalendarDateLinear';
import SolarCalendarLinear from './SolarCalendarLinear';
import SolarCalendarWeekLinear from './SolarCalendarWeekLinear';
import SolarCard2Linear from './SolarCard2Linear';
import SolarCheckCircleBold from './SolarCheckCircleBold';
import SolarCheckCircleLinear from './SolarCheckCircleLinear';
import SolarChatLineLinear from './SolarChatLineLinear';
import SolarCheckReadLinear from './SolarCheckReadLinear';
import SolarChecklistMinimalisticLinear from './SolarChecklistMinimalisticLinear';
import SolarCloudUploadLinear from './SolarCloudUploadLinear';
import SolarClipboardCheckOutline from './SolarClipboardCheckOutline';
import SolarClipboardListLinear from './SolarClipboardListLinear';
import SolarCloseCircleBold from './SolarCloseCircleBold';
import SolarCloseCircleLinear from './SolarCloseCircleLinear';
import SolarColumns3Linear from './SolarColumns3Linear';
import SolarCopyLinear from './SolarCopyLinear';
import SolarCropLinear from './SolarCropLinear';
import SolarDangerCircleLinear from './SolarDangerCircleLinear';
import SolarDangerTriangleLinear from './SolarDangerTriangleLinear';
import SolarDeliveryLinear from './SolarDeliveryLinear';
import SolarDisketteLinear from './SolarDisketteLinear';
import SolarDocumentAddLinear from './SolarDocumentAddLinear';
import SolarDocumentLinear from './SolarDocumentLinear';
import SolarDocumentTextLinear from './SolarDocumentTextLinear';
import SolarDocumentsLinear from './SolarDocumentsLinear';
import SolarDollarMinimalisticLinear from './SolarDollarMinimalisticLinear';
import SolarDoubleAltArrowRightLinear from './SolarDoubleAltArrowRightLinear';
import SolarDownloadMinimalisticLinear from './SolarDownloadMinimalisticLinear';
import SolarEuroLinear from './SolarEuroLinear';
import SolarEyeClosedLinear from './SolarEyeClosedLinear';
import SolarEyeLinear from './SolarEyeLinear';
import SolarFileCheckLinear from './SolarFileCheckLinear';
import SolarFileDownloadLinear from './SolarFileDownloadLinear';
import SolarFileTextLinear from './SolarFileTextLinear';
import SolarFilterLinear from './SolarFilterLinear';
import SolarFolderOpenLinear from './SolarFolderOpenLinear';
import SolarForbiddenCircleLinear from './SolarForbiddenCircleLinear';
import SolarFullScreenSquareLinear from './SolarFullScreenSquareLinear';
import SolarGlobalLinear from './SolarGlobalLinear';
import SolarGraphUpLinear from './SolarGraphUpLinear';
import SolarHistoryLinear from './SolarHistoryLinear';
import SolarHome2Linear from './SolarHome2Linear';
import SolarHourglassLineLinear from './SolarHourglassLineLinear';
import SolarInfoCircleLinear from './SolarInfoCircleLinear';
import SolarKeyLinear from './SolarKeyLinear';
import SolarLetterLinear from './SolarLetterLinear';
import SolarLikeLinear from './SolarLikeLinear';
import SolarListLinear from './SolarListLinear';
import SolarLockKeyholeMinimalisticLinear from './SolarLockKeyholeMinimalisticLinear';
import SolarLockKeyholeMinimalisticUnlockedLinear from './SolarLockKeyholeMinimalisticUnlockedLinear';
import SolarLogout2Linear from './SolarLogout2Linear';
import SolarMagniferLinear from './SolarMagniferLinear';
import SolarMenuDotsBold from './SolarMenuDotsBold';
import SolarMinusCircleLinear from './SolarMinusCircleLinear';
import SolarNotesLinear from './SolarNotesLinear';
import SolarPaperclipLinear from './SolarPaperclipLinear';
import SolarPauseCircleLinear from './SolarPauseCircleLinear';
import SolarPenLinear from './SolarPenLinear';
import SolarPenNewSquareLinear from './SolarPenNewSquareLinear';
import SolarPhoneCallingLinear from './SolarPhoneCallingLinear';
import SolarPinBold from './SolarPinBold';
import SolarPinLinear from './SolarPinLinear';
import SolarPlain2Linear from './SolarPlain2Linear';
import SolarPlayBold from './SolarPlayBold';
import SolarPlayCircleLinear from './SolarPlayCircleLinear';
import SolarRecordCircleLinear from './SolarRecordCircleLinear';
import SolarRefreshLinear from './SolarRefreshLinear';
import SolarRestartLinear from './SolarRestartLinear';
import SolarRocket2Linear from './SolarRocket2Linear';
import SolarServerSquareLinear from './SolarServerSquareLinear';
import SolarSettingsLinear from './SolarSettingsLinear';
import SolarShareCircleLinear from './SolarShareCircleLinear';
import SolarShareLinear from './SolarShareLinear';
import SolarSortVerticalLinear from './SolarSortVerticalLinear';
import SolarStarBold from './SolarStarBold';
import SolarStarsLinear from './SolarStarsLinear';
import SolarStopCircleLinear from './SolarStopCircleLinear';
import SolarSquareTransferHorizontalLinear from './SolarSquareTransferHorizontalLinear';
import SolarSun2BoldDuotone from './SolarSun2BoldDuotone';
import SolarSun2Linear from './SolarSun2Linear';
import SolarSunriseLinear from './SolarSunriseLinear';
import SolarTelegramLinear from './SolarTelegramLinear';
import SolarTableLinear from './SolarTableLinear';
import SolarToolboxLinear from './SolarToolboxLinear';
import SolarTrashBinMinimalisticLinear from './SolarTrashBinMinimalisticLinear';
import SolarUndoLeftLinear from './SolarUndoLeftLinear';
import SolarUndoLeftRoundLinear from './SolarUndoLeftRoundLinear';
import SolarUnreadLinear from './SolarUnreadLinear';
import SolarUserCrossLinear from './SolarUserCrossLinear';
import SolarUserIdLinear from './SolarUserIdLinear';
import SolarUserLinear from './SolarUserLinear';
import SolarUserPlusLinear from './SolarUserPlusLinear';
import SolarUserSpeakRoundedLinear from './SolarUserSpeakRoundedLinear';
import SolarUsersGroupRoundedLinear from './SolarUsersGroupRoundedLinear';
import SolarWalletLinear from './SolarWalletLinear';
import SolarWalletMoneyLinear from './SolarWalletMoneyLinear';
import SolarWidget4Linear from './SolarWidget4Linear';
import SolarWidget5Linear from './SolarWidget5Linear';

const ICONS: Record<string, ComponentType<SVGProps<SVGSVGElement>>> = {
    'plus': SolarAddCircleLinear,
    'plus-lg': SolarAddCircleLinear,
    'plus-circle': SolarAddCircleLinear,
    'plus-circle-fill': SolarAddCircleBold,
    'dash': SolarMinusCircleLinear,
    'dash-circle': SolarMinusCircleLinear,
    'trash': SolarTrashBinMinimalisticLinear,
    'trash3': SolarTrashBinMinimalisticLinear,
    'box-seam': SolarBoxMinimalisticLinear,
    'three-dots': SolarMenuDotsBold,
    'stars': SolarStarsLinear,
    'funnel': SolarFilterLinear,
    'x-lg': SolarCloseCircleLinear,
    'x-circle': SolarCloseCircleLinear,
    'x-circle-fill': SolarCloseCircleBold,
    'search': SolarMagniferLinear,
    'pencil-square': SolarPenNewSquareLinear,
    'pencil': SolarPenLinear,
    'box-arrow-in-down': SolarDownloadMinimalisticLinear,
    'box-arrow-right': SolarLogout2Linear,
    'gear': SolarSettingsLinear,
    'paperclip': SolarPaperclipLinear,
    'chevron-left': SolarAltArrowLeftLinear,
    'chevron-right': SolarAltArrowRightLinear,
    'chevron-up': SolarAltArrowUpLinear,
    'chevron-down': SolarAltArrowDownLinear,
    'chevron-double-right': SolarDoubleAltArrowRightLinear,
    'card-list': SolarClipboardListLinear,
    'arrow-clockwise': SolarRefreshLinear,
    'arrow-repeat': SolarRefreshLinear,
    'copy': SolarCopyLinear,
    'collection': SolarWidget4Linear,
    'check2-all': SolarCheckReadLinear,
    'cash-coin': SolarWalletMoneyLinear,
    'building': SolarBuildingsLinear,
    'stop-circle': SolarStopCircleLinear,
    'people': SolarUsersGroupRoundedLinear,
    'check-circle': SolarCheckCircleLinear,
    'check-circle-fill': SolarCheckCircleBold,
    'check2-circle': SolarCheckCircleLinear,
    'file-earmark-arrow-down': SolarFileDownloadLinear,
    'columns': SolarColumns3Linear,
    'table': SolarTableLinear,
    'columns-gap': SolarWidget5Linear,
    'clock-history': SolarHistoryLinear,
    'chat-left-text': SolarChatLineLinear,
    'play-fill': SolarPlayBold,
    'play-circle': SolarPlayCircleLinear,
    'pin-angle': SolarPinLinear,
    'pin-angle-fill': SolarPinBold,
    'person-vcard': SolarUserIdLinear,
    'person-plus': SolarUserPlusLinear,
    'info-circle': SolarInfoCircleLinear,
    'floppy': SolarDisketteLinear,
    'exclamation-triangle': SolarDangerTriangleLinear,
    'exclamation-circle': SolarDangerCircleLinear,
    'exclamation-octagon': SolarDangerTriangleLinear,
    'check2': SolarUnreadLinear,
    'check-lg': SolarUnreadLinear,
    'briefcase': SolarToolboxLinear,
    'toolbox': SolarToolboxLinear,
    'arrow-bar-right': SolarLogout2Linear,
    'transfer': SolarSquareTransferHorizontalLinear,
    'ui-checks-grid': SolarChecklistMinimalisticLinear,
    'truck': SolarDeliveryLinear,
    'sunrise': SolarSunriseLinear,
    'sticky': SolarNotesLinear,
    'rocket-takeoff': SolarRocket2Linear,
    'pause-circle': SolarPauseCircleLinear,
    'person-x': SolarUserCrossLinear,
    'person-lines-fill': SolarUserSpeakRoundedLinear,
    'list-ul': SolarListLinear,
    'hourglass-split': SolarHourglassLineLinear,
    'hand-thumbs-up': SolarLikeLinear,
    'graph-up-arrow': SolarGraphUpLinear,
    'filetype-csv': SolarFileTextLinear,
    'file-earmark-text': SolarDocumentTextLinear,
    'file-earmark-richtext': SolarDocumentTextLinear,
    'file-earmark-plus': SolarDocumentAddLinear,
    'file-earmark-check': SolarFileCheckLinear,
    'file-earmark': SolarDocumentLinear,
    'file-earmark-pdf': SolarFileTextLinear,
    'file-earmark-excel': SolarFileTextLinear,
    'eye': SolarEyeLinear,
    'eye-slash': SolarEyeClosedLinear,
    'envelope': SolarLetterLinear,
    'clipboard-check': SolarClipboardCheckOutline,
    'card-text': SolarDocumentTextLinear,
    'calendar3': SolarCalendarLinear,
    'calendar-week': SolarCalendarWeekLinear,
    'calendar-date': SolarCalendarDateLinear,
    'brightness-high': SolarSun2Linear,
    'brightness-high-fill': SolarSun2BoldDuotone,
    'bootstrap-reboot': SolarRestartLinear,
    'bookmark-star': SolarBookmarkSquareLinear,
    'bookmark-fill': SolarBookmarkBold,
    'bookmark-check-fill': SolarClipboardCheckOutline,
    'arrow-return-left': SolarUndoLeftRoundLinear,
    'arrow-counterclockwise': SolarUndoLeftLinear,
    'archive': SolarArchiveLinear,
    'archive-fill': SolarArchiveDownLinear,
    'wallet2': SolarWalletLinear,
    'telephone-outbound': SolarPhoneCallingLinear,
    'sun-fill': SolarSun2BoldDuotone,
    'star-fill': SolarStarBold,
    'slash-circle': SolarForbiddenCircleLinear,
    'share': SolarShareLinear,
    'share-fill': SolarShareCircleLinear,
    'send': SolarPlain2Linear,
    'person-workspace': SolarUserSpeakRoundedLinear,
    'person': SolarUserLinear,
    'lock': SolarLockKeyholeMinimalisticLinear,
    'unlock': SolarLockKeyholeMinimalisticUnlockedLinear,
    'home': SolarHome2Linear,
    'hdd-stack': SolarServerSquareLinear,
    'grip-vertical': SolarAlignVerticalSpacingLinear,
    'globe2': SolarGlobalLinear,
    'folder2-open': SolarFolderOpenLinear,
    'fingerprint': SolarKeyLinear,
    'files': SolarDocumentsLinear,
    'currency-euro': SolarEuroLinear,
    'currency-dollar': SolarDollarMinimalisticLinear,
    'crop': SolarCropLinear,
    'credit-card': SolarCard2Linear,
    'cloud-upload': SolarCloudUploadLinear,
    'circle': SolarRecordCircleLinear,
    'caret-up-fill': SolarAltArrowUpLinear,
    'caret-down-fill': SolarAltArrowDownLinear,
    'card-checklist': SolarChecklistMinimalisticLinear,
    'bell': SolarBellLinear,
    'aspect-ratio': SolarFullScreenSquareLinear,
    'arrow-up': SolarArrowUpLinear,
    'arrow-right': SolarArrowRightLinear,
    'arrow-down-up': SolarSortVerticalLinear,
    'telegram': SolarTelegramLinear,
};

export type SolarIconName = keyof typeof ICONS | string;

export interface SolarIconProps extends Omit<SVGProps<SVGSVGElement>, 'title'> {
    name: SolarIconName;
    title?: string;
}

const parseIconName = (name: string): { key: string; extraClass: string } => {
    const tokens = String(name || '').trim().split(/\s+/).filter(Boolean);
    if (!tokens.length) return { key: 'info-circle', extraClass: '' };
    if (tokens.some((token) => token === 'bi' || token.startsWith('bi-'))) {
        let key = 'info-circle';
        const extra: string[] = [];
        for (const token of tokens) {
            if (token === 'bi') continue;
            if (token.startsWith('bi-')) key = token.slice(3);
            else extra.push(token);
        }
        return { key, extraClass: extra.join(' ') };
    }
    return { key: tokens[0].replace(/^bi-/, ''), extraClass: tokens.slice(1).join(' ') };
};

export default function SolarIcon({ name, className, title, ...props }: SolarIconProps) {
    const parsed = parseIconName(name);
    const Icon = ICONS[parsed.key] || ICONS['info-circle'];
    return (
        <Icon
            width="1em"
            height="1em"
            className={['solar-icon', parsed.extraClass, className].filter(Boolean).join(' ')}
            {...props}
            {...(title ? ({ title } as SVGProps<SVGSVGElement>) : {})}
        />
    );
}
